import { render, staticRenderFns } from "./LegalDocumentsRegistry.vue?vue&type=template&id=1f4f661c&scoped=true&"
import script from "./LegalDocumentsRegistry.vue?vue&type=script&lang=js&"
export * from "./LegalDocumentsRegistry.vue?vue&type=script&lang=js&"
import style0 from "./LegalDocumentsRegistry.vue?vue&type=style&index=0&id=1f4f661c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f4f661c",
  null
  
)

export default component.exports